export default __webpack_public_path__ + "static/media/logo_red.80f41a61.png";